<template>
    <div class="ppv2-space-y-4">
        <InfoMessageBox
            class="ppv2-mt-2"
            :title="$t('messageBox.devis.start.title')"
            color="info"
            :customIcon="customIconStart"
        />

        <div class="ppv2-flex ppv2-flex-col ppv2-space-y-4">
            <div class="ppv2-relative ppv2-p-4 ppv2-cursor-pointer">
                <div class="ppv2-absolute ppv2-top-2 ppv2-right-2">
                    <BaseSwitch v-model="formData.make_devis_with_time_slot" required :disabled="false" />
                </div>
                <div>
                    <div class="ppv2-text-base ppv2-text-gray-800 poppinsMedium">
                        <BaseLabel :label="$t('devis.fields.makeDevisWithTimeSlot.label')" />
                    </div>
                    <div class="ppv2-flex ppv2-items-center ppv2-space-x-2 ppv2-mt-1 ppv2-text-xs ppv2-text-gray-500">
                        <BaseParagraphe> {{ $t('devis.fields.makeDevisWithTimeSlot.description') }} </BaseParagraphe>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import InfoMessageBox from '../../../Shared/InfoMessageBox.vue'
import BaseParagraphe from '../../../Shared/BaseParagraphe.vue'
import BaseSwitch from '../../../Shared/BaseSwitch.vue'
import BaseLabel from '../../../Shared/BaseLabel.vue'

export default {
    name: 'DevisForm',
    components: {
        InfoMessageBox,
        BaseParagraphe,
        BaseSwitch,
        BaseLabel,
    },
    props: {
        establishment: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            customIconStart: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 5L5 19M9 6.5C9 7.88071 7.88071 9 6.5 9C5.11929 9 4 7.88071 4 6.5C4 5.11929 5.11929 4 6.5 4C7.88071 4 9 5.11929 9 6.5ZM20 17.5C20 18.8807 18.8807 20 17.5 20C16.1193 20 15 18.8807 15 17.5C15 16.1193 16.1193 15 17.5 15C18.8807 15 20 16.1193 20 17.5Z" stroke="#021832" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>`,
            isInitializing: true,
            formData: {
                make_devis_with_time_slot: false,
            },
        }
    },
    watch: {
        formData: {
            deep: true,
            handler(newVal) {
                if (this.isInitializing) return
                this.$emit('update', newVal)
            },
        },
    },
    methods: {
        initializeData() {
            if (this.establishment) {
                this.formData.make_devis_with_time_slot = !!this.establishment.make_devis_with_time_slot
            }
        },
    },
    created() {
        this.initializeData()
        this.$nextTick(() => {
            this.isInitializing = false
        })
    },
}
</script>

<style scoped></style>
